import $ from 'jquery';

const complaints =  {

    init: () => {

        let companySelect = $('.complaints .contact-form__row--select[data-select="select-company"] select'),
            personRow = $('.complaints .contact-form__row--select[data-select="select-person"]'),
            personSelect = $('.complaints .contact-form__row--select[data-select="select-person"] select'),
            complaintDescriptions = document.querySelectorAll('.complaints .complaint-description');

        companySelect.on('change', function() {
            if (personRow.css('display') === 'none') {
                personRow.css('display', 'block');
            } else {
                reloadComplaints();
            }
        });

        personSelect.on('change', function() {
            reloadComplaints();
        });

        const reloadComplaints = function() {
            let selectedCompany = document.querySelector('.complaints .contact-form__row--select[data-select="select-company"] option:checked').dataset.company;
            let selectedPerson = document.querySelector('.complaints .contact-form__row--select[data-select="select-person"] option:checked').dataset.person;
            complaintDescriptions.forEach(description => {
                description.style.display = 'none';
            });
            document.querySelector(`.complaints .complaint-description[data-company=${selectedCompany}][data-person=${selectedPerson}]`).style.display = 'block';
        }

    }

}

export default complaints;